import "core-js/modules/es.array.push.js";
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "wh100"
};
const _hoisted_2 = {
  key: 0,
  class: "layout-v center",
  style: {
    "margin-top": "100px"
  }
};
const _hoisted_3 = {
  key: 1
};
const _hoisted_4 = {
  style: {
    "margin": "0 24px"
  }
};
const _hoisted_5 = {
  style: {
    "padding": "12px",
    "font-size": "14px"
  }
};
const _hoisted_6 = {
  class: "layout-h center"
};
const _hoisted_7 = {
  class: "fill",
  style: {
    "font-weight": "bold",
    "font-size": "16px"
  }
};
const _hoisted_8 = {
  class: "layout-h center pd25"
};
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", null, "出栏数量：", -1);
const _hoisted_10 = {
  style: {
    "color": "var(--van-text-color-2)"
  }
};
const _hoisted_11 = {
  class: "layout-h center pd25"
};
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", null, "出栏年龄：", -1);
const _hoisted_13 = {
  style: {
    "color": "var(--van-text-color-2)"
  }
};
const _hoisted_14 = {
  class: "layout-h center pd25"
};
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", null, "出栏时间：", -1);
const _hoisted_16 = {
  style: {
    "color": "var(--van-text-color-2)"
  }
};
const _hoisted_17 = {
  class: "pd25",
  style: {
    "font-size": "12px",
    "color": "rgba(0,0,0,0.6)"
  }
};
const _hoisted_18 = {
  style: {}
};
import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import FetchHelper from '../../utils/helper/fetch-helper';
import { showConfirmDialog } from 'vant';
export default {
  __name: 'index',
  setup(__props) {
    const router = useRouter();
    const datas = ref([]);
    const loading = ref(false);
    const finished = ref(false);
    const searchValue = ref(null);
    const pageNum = ref(1);
    const search = value => {
      searchValue.value = value;
      requestDatas();
    };
    const requestDatas = () => {
      loading.value = true;
      FetchHelper.getJson(`h5api/cltb/yakCltb/list`, {
        searchValue: searchValue.value,
        pageSize: 10,
        pageNum: pageNum.value
      }).then(resp => {
        if (resp.rows) {
          var _datas$value, _datas$value2;
          datas.value = [...datas.value, ...resp.rows];
          loading.value = false;
          console.log((_datas$value = datas.value) === null || _datas$value === void 0 ? void 0 : _datas$value.length, resp.totalCount);
          if (((_datas$value2 = datas.value) === null || _datas$value2 === void 0 ? void 0 : _datas$value2.length) >= resp.totalCount) {
            finished.value = true;
          } else {
            pageNum.value = pageNum.value + 1;
            finished.value = false;
          }
          // finished.value = true;
        }
      }).finally(e => {
        loading.value = false;
      });
    };
    const onLoad = () => {
      requestDatas();
    };
    const deleteItem = item => {
      showConfirmDialog({
        title: '提示',
        message: '确认删除该条数据？'
      }).then(() => {
        FetchHelper.deleteJson(`/h5api/cltb/yakCltb/${item.id}`).then(resp => {
          datas.value = [];
          finished.value = false;
        });
      }).catch(() => {});
    };
    onMounted(() => {});
    const navToEdit = (id, type) => {
      router.push({
        name: 'cltb-edit',
        params: {
          id: id,
          type
        }
      });
    };
    return (_ctx, _cache) => {
      const _component_van_button = _resolveComponent("van-button");
      const _component_van_empty = _resolveComponent("van-empty");
      const _component_van_search = _resolveComponent("van-search");
      const _component_van_grid_item = _resolveComponent("van-grid-item");
      const _component_van_grid = _resolveComponent("van-grid");
      const _component_van_cell_group = _resolveComponent("van-cell-group");
      const _component_van_space = _resolveComponent("van-space");
      const _component_van_list = _resolveComponent("van-list");
      const _component_van_floating_bubble = _resolveComponent("van-floating-bubble");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [datas.value.length === 0 && finished.value ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_van_empty, {
        image: "search",
        description: "您还未提交过填报"
      }, {
        default: _withCtx(() => [_createVNode(_component_van_button, {
          plain: "",
          round: "",
          type: "primary",
          class: "bottom-button",
          onClick: _cache[0] || (_cache[0] = $event => navToEdit('new', 'add'))
        }, {
          default: _withCtx(() => [_createTextVNode("申请填报")]),
          _: 1
        })]),
        _: 1
      })])) : _createCommentVNode("", true), !finished.value || datas.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_van_search, {
        placeholder: "请输入搜索关键词",
        onSearch: search,
        shape: "round",
        background: "#f8f8f8"
      })]), _createVNode(_component_van_list, {
        onLoad: onLoad,
        loading: loading.value,
        finished: finished.value,
        "finished-text": "没有更多了"
      }, {
        default: _withCtx(() => [_createVNode(_component_van_space, {
          direction: "vertical",
          fill: ""
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datas.value, item => {
            return _openBlock(), _createBlock(_component_van_cell_group, {
              inset: ""
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString(item.name), 1), _createVNode(_component_van_button, {
                icon: "delete-o",
                type: "danger",
                size: "mini",
                round: "",
                plain: "",
                onClick: $event => deleteItem(item)
              }, null, 8, ["onClick"])]), _createElementVNode("div", _hoisted_8, [_hoisted_9, _createElementVNode("div", _hoisted_10, _toDisplayString(item.number), 1)]), _createElementVNode("div", _hoisted_11, [_hoisted_12, _createElementVNode("div", _hoisted_13, _toDisplayString(item.age), 1)]), _createElementVNode("div", _hoisted_14, [_hoisted_15, _createElementVNode("div", _hoisted_16, _toDisplayString(item.clDate), 1)]), _createElementVNode("div", _hoisted_17, _toDisplayString(item.areaCodeName), 1)]), _createElementVNode("div", _hoisted_18, [_createVNode(_component_van_grid, {
                "column-num": 2,
                direction: "horizontal"
              }, {
                default: _withCtx(() => [_createVNode(_component_van_grid_item, {
                  text: "修改",
                  onClick: $event => navToEdit(item.id, 'edit')
                }, null, 8, ["onClick"]), _createVNode(_component_van_grid_item, {
                  text: "查看任务详情",
                  onClick: $event => navToEdit(item.id, 'detail')
                }, null, 8, ["onClick"])]),
                _: 2
              }, 1024)])]),
              _: 2
            }, 1024);
          }), 256))]),
          _: 1
        })]),
        _: 1
      }, 8, ["loading", "finished"])])) : _createCommentVNode("", true), _createVNode(_component_van_floating_bubble, {
        icon: "plus",
        onClick: _cache[1] || (_cache[1] = $event => navToEdit('new', 'add')),
        gap: "28"
      })]);
    };
  }
};